import { observer } from "mobx-react";
import * as React from "react";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { JobCategoryEditDetailsForm } from "../JobCategoryEditDetailsForm";
import { pushRoute } from "../../app/router/history";
import { HrRoutes } from "../router/HrRoutes";
import { API } from "../../../network/API";
import { JobCategoryCreatePayload } from "../../../network/APITypes";
import { THEME } from "../../../theme/ThemeStore";

export const JobCategoryEditDetailsSite = observer(() => {
    const handleSubmit = async (values: JobCategoryCreatePayload) => {
        try {
            const payload = {
                ...values,
                isDal: THEME.THEME_NAME === "dal"
            };
            await API.postJobCategory(payload);
            pushRoute(HrRoutes.JOB_CATEGORIES.ROOT);
        } catch (error) {
            console.error("Failed to create job category:", error);
        }
    };

    const handleBack = () => {
        pushRoute(HrRoutes.JOB_CATEGORIES.ROOT);
    };

    return (
        <ContentWrapper>
            <JobCategoryEditDetailsForm onSubmit={handleSubmit} onBack={handleBack} />
        </ContentWrapper>
    );
});
